module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "funreport"
  }, [_c('div', {
    staticClass: "tagsNavatar"
  }, [_c('ul', {
    class: ['tags', _vm.funreport.key]
  }, _vm._l((_vm.tags), function(item, $index) {
    return _c('li', {
      on: {
        "click": function($event) {
          _vm.countTags(item, this)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.funreport.pic.replace('animal', item).replace('../', './')
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "tagCount"
    }, [_vm._v(_vm._s(_vm.tagObj[item].num) + "\n\t\t\t\t\t"), _c('i', {
      staticClass: "add",
      on: {
        "animationend": function($event) {
          if ($event.target !== $event.currentTarget) { return null; }
          _vm.removeAnimate()
        }
      }
    }, [_vm._v("+1")]), _vm._v(" "), _c('i', {
      staticClass: "minus",
      on: {
        "animationend": function($event) {
          if ($event.target !== $event.currentTarget) { return null; }
          _vm.removeAnimate()
        }
      }
    }, [_vm._v("-1")])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "animal"
  }, [_c('router-link', {
    attrs: {
      "to": '/download'
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.funreport.pic.replace('../', './')
    }
  })])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "saveTip"
  }, [_vm._v("点击动物保存动物画像")]), _vm._v(" "), _c('p', {
    staticClass: "short_description"
  }, [_vm._v(_vm._s(_vm.funreport.short_description))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/._vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-2ba0c034!./~/._vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/components/funBody.vue
// module id = 128
// module chunks = 2